import { RoomBookingServiceBooking } from './room-booking-service-booking.model';
import { Room } from './room.model';
import { Member } from '../member/member.model';
import { CourseInstance } from '../training';

export class RoomBooking {
  courseInstance?: CourseInstance | string;
  creator?: Member | string;
  deletedAt?: string | null;
  endDate: string;
  fullDayPrice?: number;
  guestsNumber?: number;
  halfDayPrice?: number;
  id?: number;
  name: string;

  // Google Properties
  newToolsEventId?: string;
  owner?: Member | string;
  room?: Room; // URI format
  serviceBookings?: RoomBookingServiceBooking[] | string[];
  speakerName?: string;
  startDate: string;
  updatedBy?: Member | string;

  constructor(values= {}) {
    Object.assign(this, values);
    if (this.owner && 'string' !== typeof this.owner) {
      this.owner = new Member(this.owner);
    }

    if (this.creator && 'string' !== typeof this.creator) {
      this.creator = new Member(this.creator);
    }

    if (this.updatedBy && 'string' !== typeof this.updatedBy) {
      this.updatedBy = new Member(this.updatedBy);
    }
  }
}
